<template>
  <div class="menu">
    <ul>
      <li v-for="(item,index) in menuData"
        :key="index"
        :class="{liActive:isActive==index}"
        v-tap
        @tap="link(index)">
        <i class="icon iconfont"
          v-html="item.tobarIcon"></i><br>
        <span>{{item.tobarContent}}</span>

      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "order-menu",
  data() {
    return {
      isActive: "",

      menuData: [
        {
          tobarLink: "/home/order",
          tobarIcon: "&#xe624;",
          tobarContent: "下单"
        },
        {
          tobarLink: "/home/store",
          tobarIcon: "&#xe7b9;",
          tobarContent: "持仓"
        },
        {
          tobarLink: "/home/cancel",
          tobarIcon: "&#xe609;",
          tobarContent: "撤单"
        },
        {
          tobarLink: "/home/capital",
          tobarIcon: "&#xe60a;",
          tobarContent: "资金"
        },
        {
          tobarLink: "/home/query",
          tobarIcon: "&#xe603;",
          tobarContent: "查询"
        }
      ]
    };
  },
  methods: {
    isActiveValue() {
      this.isActive = this.$route.params.tableId;
      // console.log(this.isActive);
      // console.log(222);
    },
    link(index) {
      this.isActive = index;
      if (index == 3) {
        // 查询资金信息：proto.ctpfront.proto.Capital
        front.queryCapital(function(capital, error) {
          if (error !== undefined) {
            console.error(error.getMessage());
            return;
          }
          console.log(
            "capital: " + capital.getBalance() + " " + capital.getAvailable()
          );
        });
      } else if (index == 4) {
        // 委托下单：回报推送函数
        // proto.ctpfront.proto.Order
        var on_order = function(order) {
          // 委托回报on_order
          console.log(
            "on_order: " +
              order.getOrderRef() +
              " " +
              detail.getTargetId() +
              " " +
              detail.getOffset() +
              " " +
              detail.getDirection() +
              " " +
              detail.getState() +
              " " +
              detail.getStateDetail() +
              " " +
              detail.getInsertTime() +
              " " +
              detail.getTradedVolume()
          );
        };
        // proto.ctpfront.proto.Trade
        var on_trade = function(trade) {
          // 成交回报on_trade
          console.log(
            "on_trade: " +
              trade.getTradeId() +
              " " +
              detail.getTargetId() +
              " " +
              detail.getOffset() +
              " " +
              detail.getDirection() +
              " " +
              detail.getVolume() +
              " " +
              detail.getPrice() +
              " " +
              detail.getOrderId()
          );
        };
        front.subscribe(on_order, on_trade);
      }
    }
  },
  mounted() {
    this.isActiveValue();
  }
};
</script>

<style scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.45rem;
  font-style: normal;
  /*font-weight: bold;*/
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #7d2029;
}

.menu {
  height: 1.2rem;
  background: #f8f9fa;
  /*border-top: 1px solid #dddcdd;*/
  border-bottom: 1px solid #dddcdd;
  /*margin-top: 0.25rem;*/
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.menu ul {
  font-size: 0;
  text-align: center;
}

.menu ul li {
  display: inline-block;
  font-size: 0.24rem;
  /*line-height: 0.3rem;*/
  line-height: 0.42rem;
  /*color: #7d7d7d;*/
  width: 1.5rem;
  text-align: center;
  padding-top: 0.18rem;
}

.menu ul li span {
  /*font-size: 0.32rem;*/
  font-size: 0.24rem;
  display: inline-block;
  margin-bottom: 0.05rem;
}

.liActive {
  /*background: #26a2ff;*/
  border-bottom: 2px solid #ff0100;
}
</style>



// WEBPACK FOOTER //
// src/components/common/orderMenu.vue